import { useRef, useCallback } from 'react';

const useFunction = () => {
    const fnRef = useRef();

    const setFunction = useCallback((action) => {
        fnRef.current = action;
    }, []);

    const callFunction = useCallback((...args) => {
        if (typeof fnRef.current === 'function') {
            return fnRef.current(...args);
        }
    }, []);

    return [callFunction, setFunction];
};

export default useFunction;
    